import {provideEventPlugins} from "@taiga-ui/event-plugins";
import {provideAnimations} from "@angular/platform-browser/animations";
import {ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {errorInterceptor} from './shared/interceptors/error.interecepter';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {mainInterceptor} from './shared/interceptors/main.interceptor';
import {provideToastr} from 'ngx-toastr';
import {of} from 'rxjs';
import {TUI_LANGUAGE, TUI_RUSSIAN_LANGUAGE} from '@taiga-ui/i18n';
import {userTypeInterceptor} from './shared/interceptors/user-type-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideEventPlugins(),
    provideHttpClient(
      withInterceptors([mainInterceptor, errorInterceptor,userTypeInterceptor])
    ),
    provideToastr(),
    {
      provide: TUI_LANGUAGE,
      useValue: of(TUI_RUSSIAN_LANGUAGE),
    },
  ]
};
